let formTranslation = {
	required: 'A mező kitöltése kötelező',
	pattern: 'A mező értékének formátuma nem megfelelő',
	minlength: 'A mező értéke túl rövid',
	maxlength: 'A mező értéke túl hosszú',
	criteria: 'A mező értéke nem felel meg a bonyolultsági követelményeknek',
	isTheSame: 'Az itt megadott jelszó nem egyezik a fent megadottal',
	send: 'Küldés',
	cancel: 'Mégsem',
	namePlaceHolder: 'Név',
	fullName: 'Teljes név',
	nameLabel: 'Címzett neve',
	login: 'Belépés',
	loginTitle: 'Bejelentkezés',
	registration: 'Regisztráció',
	stayLoggedIn: 'Maradjon bejelentkezve',
	password: 'Jelszó',
	originalPassword: 'Jelenegi jelszó',
	forgetPassword: 'Elfelejtette jelszavát?',
	dontHaveAccount: 'Nincs még saját fiókja?',
	haveAccount: 'Van már saját fiókja?',
	acceptTermsAndConditions: 'Elfogadom az adatkezelési szabályzatot',
	firstName: 'Keresztnév',
	lastName: 'Vezetéknév',
	saveChanges: 'Változások mentése',
	subscribe: 'Feliratkozom a hírlevélre',
	phone: 'Telefonszám',
	pwAgain: 'Jelszó újra',
	changePw: 'Jelszó módosítása',
	yes: 'Igen',
	ok: 'Ok',
	delete: 'Törlés',
	close: 'Bezárás',
	forgottenPasswordTitle: 'Elfelejtett jelszó',
	sendNewPw: 'Új jelszó küldése',
	loginError: 'Hiba a bejelentkezéskor',
	loginSuccess: 'Sikeres bejelentkezés',
	regError: 'Sikertelen regisztráció',
	loginSuccessRegistrationSuccess: 'Regisztráció és bejelentkezés sikeres',
	loginErrorRegistrationSuccess: 'A regisztráció sikeres, azonban a bejelentkezés sikertelen',
	forgotPasswordSuccess: 'Az emailt elküldtük a megadott email címre',
	forgotPasswordError: 'Sikertelen email küldés',
	asSoonAs: "Minél hamarabb",
	nineToTwelve: "Munkanapokon 09 - 12 között",
	twelveToSixteen: "Munkanapokon 12 - 16 között",
	sixteenToNineteen: "Munkanapokon 16 - 19 között",
	shareLanguageLabel: 'Megosztás nyelve',
	fromNameLabel: 'Feladó',
	fromNamePlaceHolder: 'Feladó',

	/** Global notifications, errors */

	logoutSuccessNotification: 'Sikeres kijelentkezés',
	successShareNotification: 'Sikeres levélküldés',
	sendNotificationEmail: 'Kérek ajánló üzenetet ha a keresésnek megfelelő új ingatlan kerül fel az oldalra',
	technicalError: 'Technikai hiba történt',
	noOcResult: 'Az eredeti keresés nem hozott találatot, ezek az Önhöz legközelebbi irodáink',
	hack: 'Úgy került a profil oldalra, hogy nincs bejelentkezve! HACK!',
	inactiveProperty: 'A hirdetés már nem aktív',
	validationError: 'Hiba az űrlap validáció közben',
	errorOnProfileModification: 'Hiba a személyes adatok megváltoztatása közben',
	errorOnPasswordModification: 'Hiba jelszóváltoztatás közben',
	greetings: "Üdvözöljük"
};

export default formTranslation;
